import { render } from 'preact';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/base.css';
import { App } from './app/App.tsx';
import { listenForInstall } from './app/install.ts';
import { registerServiceWorker } from './app/sw-register.ts';

render(<App />, document.getElementById('app')!);
registerServiceWorker();
listenForInstall();
